import { CTASection } from "../shared/cta-section";

export const ContactUs = () => {
  return (
    <CTASection
      id="contact-us"
      title={
        <>
          Ready to{" "}
          <span className="underline underline-offset-8 text-haizea-green decoration-3 decoration-haizea-green">
            transform
          </span>{" "}
          your operations?
        </>
      }
      description="Join our growing list of successful clients. Let's discuss how satellite monitoring can revolutionize your workflow and deliver measurable results for your organisation."
      buttons={[
        {
          text: "Start Your Project",
          href: "mailto:contact@haizea.com.au",
          backgroundColorClass: "bg-haizea-green",
        },
      ]}
    />
  );
};
